/**
 * @generated SignedSource<<93b1e52bde624486e1d08806e6dec3c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditDelegatePageRouteQuery$variables = {
  address: string;
};
export type EditDelegatePageRouteQuery$data = {
  readonly delegate: {
    readonly " $fragmentSpreads": FragmentRefs<"VoterPanelFragment">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"DelegateStatementFormFragment">;
};
export type EditDelegatePageRouteQuery = {
  response: EditDelegatePageRouteQuery$data;
  variables: EditDelegatePageRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "address"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "addressOrEnsName",
    "variableName": "address"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ResolvedName",
  "kind": "LinkedField",
  "name": "resolvedName",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "type",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditDelegatePageRouteQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "address",
            "variableName": "address"
          }
        ],
        "kind": "FragmentSpread",
        "name": "DelegateStatementFormFragment"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VoterPanelFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditDelegatePageRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Delegate",
        "kind": "LinkedField",
        "name": "delegate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isContract",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateStatement",
            "kind": "LinkedField",
            "name": "statement",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statement",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discord",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "twitter",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TopIssue",
                "kind": "LinkedField",
                "name": "topIssues",
                "plural": true,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TopStakeholder",
                "kind": "LinkedField",
                "name": "topStakeholders",
                "plural": true,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DelegateMetrics",
            "kind": "LinkedField",
            "name": "delegateMetrics",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tokenHoldersRepresentedCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "proposalsCreated",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ofLastTenProps",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forVotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "againstVotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalVotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ofTotalProps",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VotingPower",
            "kind": "LinkedField",
            "name": "tokensRepresentedVote",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bpsOfTotal",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bpsOfStakedSupply",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TokenAmount",
                "kind": "LinkedField",
                "name": "amount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "decimals",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Delegate",
            "kind": "LinkedField",
            "name": "delegatingTo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Address",
                "kind": "LinkedField",
                "name": "address",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cea7db41f78415c0d18324b3cc128568",
    "id": null,
    "metadata": {},
    "name": "EditDelegatePageRouteQuery",
    "operationKind": "query",
    "text": "query EditDelegatePageRouteQuery(\n  $address: String!\n) {\n  ...DelegateStatementFormFragment_2WA0fu\n  delegate(addressOrEnsName: $address) {\n    ...VoterPanelFragment\n    id\n  }\n}\n\nfragment DelegateFromListRowFragment on DelegateMetrics {\n  tokenHoldersRepresentedCount\n}\n\nfragment DelegateProfileImageFragment on Delegate {\n  address {\n    resolvedName {\n      address\n      ...NounResolvedNameFragment\n      ...ENSAvatarFragment\n    }\n  }\n  tokensRepresentedVote {\n    amount {\n      ...TokenAmountDisplayFragment\n    }\n  }\n}\n\nfragment DelegateStatementFormFragment_2WA0fu on Query {\n  delegate(addressOrEnsName: $address) {\n    address {\n      isContract\n      resolvedName {\n        address\n        name\n      }\n    }\n    statement {\n      statement\n      discord\n      twitter\n      topIssues {\n        type\n        value\n      }\n      topStakeholders {\n        type\n        value\n      }\n    }\n    id\n  }\n}\n\nfragment DelegatingToRowFragment on Delegate {\n  delegatingTo {\n    address {\n      resolvedName {\n        address\n        name\n      }\n    }\n    id\n  }\n}\n\nfragment ENSAvatarFragment on ResolvedName {\n  name\n}\n\nfragment ForAgainstAbstainRowFragment on Delegate {\n  delegateMetrics {\n    forVotes\n    againstVotes\n  }\n}\n\nfragment NounResolvedNameFragment on ResolvedName {\n  address\n  name\n}\n\nfragment ProposalsCreatedRowFragment on DelegateMetrics {\n  proposalsCreated\n}\n\nfragment ProposalsVotedRowFragment on Delegate {\n  delegateMetrics {\n    totalVotes\n    ofTotalProps\n  }\n}\n\nfragment RecentActivityRowFragment on DelegateMetrics {\n  ofLastTenProps\n}\n\nfragment TokenAmountDisplayFragment on TokenAmount {\n  amount\n  decimals\n  currency\n}\n\nfragment VotePowerRowFragment on Delegate {\n  tokensRepresentedVote {\n    bpsOfTotal\n    bpsOfStakedSupply\n  }\n}\n\nfragment VoterPanelActionsDelegateButtonFragment on Delegate {\n  address {\n    resolvedName {\n      address\n    }\n  }\n}\n\nfragment VoterPanelActionsFragment on Delegate {\n  statement {\n    twitter\n    discord\n  }\n  ...VoterPanelActionsDelegateButtonFragment\n}\n\nfragment VoterPanelFragment on Delegate {\n  delegateMetrics {\n    ...DelegateFromListRowFragment\n    ...ProposalsCreatedRowFragment\n    ...RecentActivityRowFragment\n  }\n  ...ForAgainstAbstainRowFragment\n  ...VotePowerRowFragment\n  ...ProposalsVotedRowFragment\n  ...DelegateProfileImageFragment\n  ...VoterPanelActionsFragment\n  ...DelegatingToRowFragment\n}\n"
  }
};
})();

(node as any).hash = "71cb1b88128903a476c027aa4183ac85";

export default node;
